const v = () => new Date().toISOString().slice(0, 10).replace(/-/g, '');
const modules = [
  // React Modules
  // {
  //   name: 'ShopAccessories',
  //   loader: () => import('./modules/react/shop-accessories/ShopAccessoriesRoot.js'),
  //   async render(Root, el) {
  //     const store = await import('./modules/react/shop-accessories/store/index.js');
  //     createRoot(el[0]).render(<Provider store={store.store}><Root rootElement={el[0]} /></Provider>);
  //   },
  // },
  // JS Modules
  // {
  //   name: 'Typography',
  //   loader: () => import(`./components/Typography.js?v=${v()}`),
  // },
];

export default [...modules];
